import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { LuFileQuestion } from 'react-icons/lu';
import {
  RoundButton,
  RoundButtonProps,
  RoundButtonHandle,
} from './RoundButton';

export const RoundHelpButton = forwardRef<
  RoundButtonHandle,
  React.PropsWithChildren<RoundButtonProps>
>(({ size = 'md', ...props }, ref) => (
  <RoundButton ref={ref} size={size} {...props}>
    <LuFileQuestion
      className={clsx(
        size === 'xs' && 'text-4xl',
        size === 'sm' && 'text-4xl',
        size === 'md' && 'text-6xl',
        size === 'lg' && 'text-8xl',
      )}
    />
  </RoundButton>
));

RoundHelpButton.displayName = 'RoundHelpButton';
